import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { duckify, filterDuck } from 'utils/duckify';
import { reviewSchoolYears as reviewSchoolYearsDuck } from 'ducks';
import Routes from '../../../routes';
import withSchoolYear from '../../hocs/withSchoolYear';
import MyReviewsHeader from './MyReviewsHeader';
import MyReviewsContactList from './MyReviewsContactList';

const MyReviews = ({
  reviewSchoolYears,
  schoolYearId,
  onSchoolYearChange,
  router,
  allDucksReady
}) => {
  const [reviewYear, setReviewYear] = useState();

  useEffect(() => {
    if (allDucksReady && reviewSchoolYears.length > 0) {
      const urlParams = new URLSearchParams(window.location.search);
      let currentSchoolYear;

      if (schoolYearId) {
        currentSchoolYear = reviewSchoolYears.find(year => schoolYearId === year.id);
      }

      if (!currentSchoolYear) {
        // eslint-disable-next-line prefer-destructuring
        currentSchoolYear = reviewSchoolYears[0];

        urlParams.delete('school_year_id');
        router.replace(`${window.location.pathname}?${urlParams.toString()}`);
      }
      setReviewYear(currentSchoolYear);
    }
  }, [allDucksReady]);

  const changeYear = year => {
    onSchoolYearChange(year);
    setReviewYear(reviewSchoolYears.find(y => y.id === year));
  };

  return (
    <div className='review-contact-list'>
      {allDucksReady && (
        <React.Fragment>
          <MyReviewsHeader
            onSchoolYearChange={changeYear}
            schoolYears={reviewSchoolYears}
            schoolYearId={reviewYear ? reviewYear.id : ''}
          />
          {reviewYear ? (
            <MyReviewsContactList reviewYear={reviewYear} />
          ) : (
            <div className='review-contact-list__card'>
              <div className='review-contact-list__card-body'>
                <span>Review has not been setup for any school year. Visit&nbsp;</span>
                <a href={Routes.review_path()}>Review Settings</a>
                <span>&nbsp;to setup a review year.</span>
              </div>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

MyReviews.propTypes = {
  /** reviewSchoolYears Duck */
  reviewSchoolYears: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  ),

  /** withSchoolYear HOC objects and functions */
  schoolYearId: PropTypes.string,
  onSchoolYearChange: PropTypes.func,

  /** react-router objects */
  router: PropTypes.shape({
    replace: PropTypes.func
  }).isRequired,

  /** allDucksReady prop */
  allDucksReady: PropTypes.bool
};

MyReviews.defaultProps = {
  reviewSchoolYears: [],
  schoolYearId: '',
  allDucksReady: false,
  onSchoolYearChange: () => false
};

const mapDucksToProps = () => ({
  reviewSchoolYears: filterDuck(reviewSchoolYearsDuck, { review_enabled: true })
});

export default compose(
  duckify(mapDucksToProps),
  withSchoolYear(() => '')
)(MyReviews);
